import { useContext, useMemo } from 'react';
import { IPromoModalProps } from '@cian/frontend-newbuilding-promo-modal-widget';
import { PromoOfferCardContext } from '../../../utils/promoOfferCardContext';

export const usePreparedOfferPromo = (): IPromoModalProps['promo'] | null => {
  const { promoInfo } = useContext(PromoOfferCardContext);

  return useMemo(() => {
    /* istanbul ignore next */
    if (!promoInfo) {
      return null;
    }

    return {
      authorName: `Застройщик ${promoInfo.providerName}`,
      name: promoInfo.title,
      type: promoInfo.promoType,
      features: promoInfo.promoProps.map(prop => ({
        name: prop.title,
        value: prop.value,
        valueChange: undefined, // Добавить после реализации на беке в CD-236749
      })),
      banks: [],
      description: promoInfo.promoDescription,
      availableJks: [],
      labels: [], // Добавить после реализации на беке в CD-236749
      fullCreditPriceTitle: undefined, // Добавить после реализации на беке в CD-236749
      availablePurchaseTerms: [], // Добавить после реализации на беке в CD-236749
      mortgageLegalInfo: undefined, // Добавить после реализации на беке в CD-236749
    } as IPromoModalProps['promo'];
  }, [promoInfo]);
};
